import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  @media screen and (max-width: 767px) {
    svg {
      width: 152px;
      height: 140px;
    }
  }
`;
const ErrorIllustration = () => {
  return (
    <Wrapper>
      <svg xmlns="http://www.w3.org/2000/svg" width="250" height="191" viewBox="0 0 250 191">
        <defs>
          <linearGradient id="prefix__b" x1="0%" x2="97.875%" y1="100%" y2="100%">
            <stop offset="0%" stopColor="#DDE5E9" />
            <stop offset="100%" stopColor="#CAD2D6" />
          </linearGradient>
          <path
            id="prefix__a"
            d="M4.124 158h116.294a3.333 3.333 0 003.333-3.333V31.327c0-.444-.177-.87-.493-1.183L93.368.484A1.667 1.667 0 0092.194 0H4.124a4 4 0 00-4 4v150a4 4 0 004 4z"
          />
        </defs>
        <g fill="none" fillRule="evenodd">
          <path
            fill="#ACBEC7"
            d="M229 63a1 1 0 011 1v2.999l3 .001a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3h-3a1 1 0 110-2h3v-3a1 1 0 011-1z"
            opacity=".352"
          />
          <path
            fill="#ACBEC7"
            d="M239 77a1 1 0 011 1v2.999l3 .001a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3h-3a1 1 0 110-2h3v-3a1 1 0 011-1z"
            opacity=".8"
          />
          <circle cx="44.071" cy="6" r="2.5" stroke="#ACBEC7" strokeWidth="3" opacity=".6" />
          <circle cx="207" cy="26" r="2.5" stroke="#ACBEC7" strokeidth="3" opacity=".6" />
          <path
            fill="#ACBEC7"
            d="M14.678 105.536a1 1 0 010 1.414l-2.12 2.12 2.12 2.122a1 1 0 11-1.415 1.415l-2.12-2.122-2.122 2.122a1 1 0 11-1.414-1.415l2.12-2.12-2.12-2.122a1 1 0 111.414-1.414l2.121 2.12 2.121-2.12a1 1 0 011.415 0z"
            opacity=".259"
          />
          <path
            fill="#ACBEC7"
            d="M44.678 182.536a1 1 0 010 1.414l-2.12 2.12 2.12 2.122a1 1 0 11-1.415 1.415l-2.12-2.122-2.122 2.122a1 1 0 11-1.414-1.415l2.12-2.12-2.12-2.122a1 1 0 111.414-1.414l2.121 2.12 2.121-2.12a1 1 0 011.415 0z"
            opacity=".514"
          />
          <path
            stroke="#ACBEC7"
            strokeWidth="4"
            d="M222.314 157.314H234.314V169.314H222.314z"
            opacity=".116"
            transform="rotate(45 228.314 163.314)"
          />
          <path
            stroke="#ACBEC7"
            strokeWidth="4"
            d="M5.385 5.314H17.384999999999998V17.314H5.385z"
            opacity=".295"
            transform="rotate(45 11.385 11.314)"
          />
          <path
            stroke="#ACBEC7"
            strokeWidth="4"
            d="M241.657 142.657H245.657V146.657H241.657z"
            opacity=".172"
            transform="rotate(45 243.657 144.657)"
          />
          <circle cx="121" cy="102.5" r="88" fill="#F1F5F7" fillRule="nonzero" />
          <g transform="translate(64 23)">
            <use fill="url(#prefix__b)" opacity=".8" xlinkHref="#prefix__a" />
            <path
              fill="#ACBEC7"
              d="M92.978 0v26.71a3.333 3.333 0 003.333 3.334h26.959"
              opacity=".4"
            />
          </g>
          <path
            fill="#FFF"
            fillRule="nonzero"
            d="M125 129c2.24 0 3.9 1.833 3.997 4 .096 2.16-1.907 4-3.997 4-2.24 0-3.9-1.833-3.997-4-.096-2.16 1.907-4 3.997-4zm0-60c11.028 0 20 9.227 20 20.569 0 9.926-6.872 18.233-15.98 20.152v9.144c0 2.284-1.8 4.135-4.02 4.135-2.22 0-4.02-1.851-4.02-4.134v-12.862c0-2.283 1.8-4.134 4.02-4.134 6.595 0 11.96-5.519 11.96-12.301s-5.365-12.3-11.96-12.3c-6.595 0-11.96 5.518-11.96 12.3 0 2.283-1.8 4.134-4.02 4.134-2.22 0-4.02-1.85-4.02-4.134C105 78.227 113.972 69 125 69z"
            opacity=".607"
          />
        </g>
      </svg>
    </Wrapper>
  );
};

export default ErrorIllustration;
